<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-12">
    <h2
      v-if="title"
      class="cf-title cf-title--2"
    >
      {{ title }}
    </h2>

    <p
      v-if="subtitle"
      class="cf-subtitle cf-subtitle--1"
    >
      {{ subtitle }}
    </p>

    <div class="cf-flex cf-flex--row cf-flex--justify-center cf-flex--gap-12">
      <a
        v-if="merchant.features.aosUrl"
        :href="merchant.features.aosUrl"
        target="_blank"
      >
        <img
          style="height: var(--input-height)"
          src="/images/google-play-badge.svg"
          alt="Google Play Badge"
        >
      </a>

      <a
        v-if="merchant.features.iosUrl"
        :href="merchant.features.iosUrl"
        target="_blank"
      >
        <img
          style="height: var(--input-height)"
          src="/images/app-store-dark.svg"
          alt="App Store Badge"
        >
      </a>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CfAppDownloadBadges',

    props: {
      title: {
        type: String,
        default: ''
      },

      subtitle: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>
